<table class="MouseCoordinatesTool">
  <tr>
    <th>Lon:</th>
    <td style="width:75px;">{{mouseCoords[0] | formatNumber(4, '.')}}</td>
    <th>Lat:</th>
    <td style="width:65px;">{{mouseCoords[1] | formatNumber(4, '.')}}</td>
  </tr>
</table>
